/**
 * @flow
 * @relayHash 848f0ab0255dce8ce212458cca90121e
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type CartPage_viewer$ref = any;
export type CartPageQueryRendererQueryVariables = {||};
export type CartPageQueryRendererQueryResponse = {|
  +viewer: ?{|
    +cart: ?{|
      +__typename: string
    |},
    +$fragmentRefs: CartPage_viewer$ref,
  |}
|};
export type CartPageQueryRendererQuery = {|
  variables: CartPageQueryRendererQueryVariables,
  response: CartPageQueryRendererQueryResponse,
|};
*/


/*
query CartPageQueryRendererQuery {
  viewer {
    cart {
      __typename
      id
    }
    ...CartPage_viewer
    id
  }
}

fragment CartAdditionalProductDvd_additionalProduct on Product {
  ...CartAdditionalProduct_additionalProduct
}

fragment CartAdditionalProduct_additionalProduct on Product {
  price
}

fragment CartLineItemFotoFlat_lineItem on LineItem {
  media {
    mediaList(first: 50) {
      edges {
        node {
          variants {
            name
            url
            id
          }
          id
        }
      }
    }
  }
  product {
    event {
      name
      mainSearch
      id
    }
    id
  }
  productParams {
    __typename
    ... on FotoFlatParams {
      startnumber
    }
  }
}

fragment CartLineItemGiftcard_lineItem on LineItem {
  product {
    price
    label
    event {
      name
      banner
      id
    }
    id
  }
}

fragment CartLineItemSinglePhoto_lineItem on LineItem {
  product {
    event {
      name
      id
    }
    id
  }
  productParams {
    __typename
    ... on SingleFotoParams {
      foto {
        sgId
        variants {
          name
          url
          id
        }
        id
      }
    }
  }
}

fragment CartLineItem_lineItem on LineItem {
  product {
    type
    id
  }
  ...CartLineItemFotoFlat_lineItem
  ...CartLineItemSinglePhoto_lineItem
  ...CartLineItemGiftcard_lineItem
}

fragment CartOverviewItem_lineItem on LineItem {
  price
  ...CartLineItem_lineItem
}

fragment CartPage_viewer on Viewer {
  cart {
    order {
      orderid
      id
    }
    additionalProducts {
      id
      type
      ...CartAdditionalProductDvd_additionalProduct
    }
    id
    lineItems {
      id
      product {
        event {
          name
          id
        }
        type
        id
      }
      price
      productParams {
        __typename
        ... on SingleFotoParams {
          foto {
            sgId
            id
          }
        }
        ... on FotoFlatParams {
          startnumber
        }
      }
      ...CartOverviewItem_lineItem
    }
    totalPrice
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "price",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "variants",
  "storageKey": null,
  "args": null,
  "concreteType": "MediaFile",
  "plural": true,
  "selections": [
    (v4/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "url",
      "args": null,
      "storageKey": null
    },
    (v1/*: any*/)
  ]
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "CartPageQueryRendererQuery",
    "type": "RootQueryType",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "cart",
            "storageKey": null,
            "args": null,
            "concreteType": "Cart",
            "plural": false,
            "selections": [
              (v0/*: any*/)
            ]
          },
          {
            "kind": "FragmentSpread",
            "name": "CartPage_viewer",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "CartPageQueryRendererQuery",
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "cart",
            "storageKey": null,
            "args": null,
            "concreteType": "Cart",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              (v1/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "order",
                "storageKey": null,
                "args": null,
                "concreteType": "Order",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "orderid",
                    "args": null,
                    "storageKey": null
                  },
                  (v1/*: any*/)
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "additionalProducts",
                "storageKey": null,
                "args": null,
                "concreteType": "Product",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  (v2/*: any*/),
                  (v3/*: any*/)
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "lineItems",
                "storageKey": null,
                "args": null,
                "concreteType": "LineItem",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "product",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Product",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "event",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Event",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v1/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "mainSearch",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "banner",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      },
                      (v2/*: any*/),
                      (v1/*: any*/),
                      (v3/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "label",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  (v3/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "productParams",
                    "storageKey": null,
                    "args": null,
                    "concreteType": null,
                    "plural": false,
                    "selections": [
                      (v0/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "type": "SingleFotoParams",
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "foto",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Media",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "sgId",
                                "args": null,
                                "storageKey": null
                              },
                              (v1/*: any*/),
                              (v5/*: any*/)
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "InlineFragment",
                        "type": "FotoFlatParams",
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "startnumber",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "media",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ExtendedMediaConnection",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "mediaList",
                        "storageKey": "mediaList(first:50)",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "first",
                            "value": 50
                          }
                        ],
                        "concreteType": "MediaConnection",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "MediaEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Media",
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/),
                                  (v1/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "totalPrice",
                "args": null,
                "storageKey": null
              }
            ]
          },
          (v1/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "CartPageQueryRendererQuery",
    "id": null,
    "text": "query CartPageQueryRendererQuery {\n  viewer {\n    cart {\n      __typename\n      id\n    }\n    ...CartPage_viewer\n    id\n  }\n}\n\nfragment CartAdditionalProductDvd_additionalProduct on Product {\n  ...CartAdditionalProduct_additionalProduct\n}\n\nfragment CartAdditionalProduct_additionalProduct on Product {\n  price\n}\n\nfragment CartLineItemFotoFlat_lineItem on LineItem {\n  media {\n    mediaList(first: 50) {\n      edges {\n        node {\n          variants {\n            name\n            url\n            id\n          }\n          id\n        }\n      }\n    }\n  }\n  product {\n    event {\n      name\n      mainSearch\n      id\n    }\n    id\n  }\n  productParams {\n    __typename\n    ... on FotoFlatParams {\n      startnumber\n    }\n  }\n}\n\nfragment CartLineItemGiftcard_lineItem on LineItem {\n  product {\n    price\n    label\n    event {\n      name\n      banner\n      id\n    }\n    id\n  }\n}\n\nfragment CartLineItemSinglePhoto_lineItem on LineItem {\n  product {\n    event {\n      name\n      id\n    }\n    id\n  }\n  productParams {\n    __typename\n    ... on SingleFotoParams {\n      foto {\n        sgId\n        variants {\n          name\n          url\n          id\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment CartLineItem_lineItem on LineItem {\n  product {\n    type\n    id\n  }\n  ...CartLineItemFotoFlat_lineItem\n  ...CartLineItemSinglePhoto_lineItem\n  ...CartLineItemGiftcard_lineItem\n}\n\nfragment CartOverviewItem_lineItem on LineItem {\n  price\n  ...CartLineItem_lineItem\n}\n\nfragment CartPage_viewer on Viewer {\n  cart {\n    order {\n      orderid\n      id\n    }\n    additionalProducts {\n      id\n      type\n      ...CartAdditionalProductDvd_additionalProduct\n    }\n    id\n    lineItems {\n      id\n      product {\n        event {\n          name\n          id\n        }\n        type\n        id\n      }\n      price\n      productParams {\n        __typename\n        ... on SingleFotoParams {\n          foto {\n            sgId\n            id\n          }\n        }\n        ... on FotoFlatParams {\n          startnumber\n        }\n      }\n      ...CartOverviewItem_lineItem\n    }\n    totalPrice\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '5f55afea4c4398aa8c593c34d505976e';

module.exports = node;
